import useTemplate from "modules/preview/hooks/useTemplate";

export default function useTemplateStatus() {
  const { data } = useTemplate(false);
  return data?.functional_details?.status;
}
